import { render, staticRenderFns } from "./Operate.vue?vue&type=template&id=1ed9d1c8&scoped=true&"
import script from "./Operate.vue?vue&type=script&lang=js&"
export * from "./Operate.vue?vue&type=script&lang=js&"
import style0 from "./Operate.vue?vue&type=style&index=0&id=1ed9d1c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed9d1c8",
  null
  
)

export default component.exports